(function () {
  const CANONICAL_COMFORT_COPY = 'Comfort Colors® shirts are heavyweight and garment-dyed, giving them a soft, broken-in feel from day one. Their vintage-washed, nature-inspired hues fade gracefully over time, creating that thrifted-gem aesthetic — but with better quality and consistency. The relaxed fit and worn-in comfort make them ideal for everyday wear.';

  function textNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function replacePassage(root, startText, endText, replacement) {
    const nodes = textNodes(root);
    const complete = nodes.map((node) => node.nodeValue).join('');
    const lower = complete.toLowerCase();
    const start = lower.indexOf(startText.toLowerCase());
    if (start < 0) return false;
    const endStart = lower.indexOf(endText.toLowerCase(), start);
    if (endStart < 0) return false;
    const end = endStart + endText.length;
    let cursor = 0;
    let startNode;
    let endNode;
    let startOffset = 0;
    let endOffset = 0;
    for (const node of nodes) {
      const next = cursor + node.nodeValue.length;
      if (!startNode && start >= cursor && start <= next) {
        startNode = node;
        startOffset = start - cursor;
      }
      if (end >= cursor && end <= next) {
        endNode = node;
        endOffset = end - cursor;
        break;
      }
      cursor = next;
    }
    if (!startNode || !endNode) return false;
    const range = document.createRange();
    range.setStart(startNode, startOffset);
    range.setEnd(endNode, endOffset);
    range.deleteContents();
    range.insertNode(document.createTextNode(replacement));
    return true;
  }

  function extractPassage(root, startText, endText) {
    const nodes = textNodes(root);
    const complete = nodes.map((node) => node.nodeValue).join('');
    const lower = complete.toLowerCase();
    const start = lower.indexOf(startText.toLowerCase());
    const end = lower.indexOf(endText.toLowerCase(), start);
    if (start < 0 || end < 0 || end <= start) return null;
    let cursor = 0;
    let startNode;
    let endNode;
    let startOffset = 0;
    let endOffset = 0;
    for (const node of nodes) {
      const next = cursor + node.nodeValue.length;
      if (!startNode && start >= cursor && start <= next) {
        startNode = node;
        startOffset = start - cursor;
      }
      if (end >= cursor && end <= next) {
        endNode = node;
        endOffset = end - cursor;
        break;
      }
      cursor = next;
    }
    if (!startNode || !endNode) return null;
    const range = document.createRange();
    range.setStart(startNode, startOffset);
    range.setEnd(endNode, endOffset);
    return range.extractContents();
  }

  function cleanDescription(description) {
    description.innerHTML = description.innerHTML
      .replace(/123\s+Main\s+Street,?\s*Anytown,?\s*Country\s*(?:,?\s*or\s*)?/gi, '')
      .replace(/write to us at\s*,/gi, 'write to us at ');

    if (/write to us at\s+or\s+/i.test(description.textContent)) {
      replacePassage(description, 'write to us at', 'or', 'write to us at');
    }

    replacePassage(
      description,
      'Comfort Colors® shirts are',
      'everyday wear.',
      CANONICAL_COMFORT_COPY
    );
  }

  function addColorPrompt(info) {
    const picker = info.querySelector('variant-selects, variant-radios');
    if (!picker || picker.querySelector('.olds-cool-color-prompt')) return;
    const labels = Array.from(picker.querySelectorAll('label, legend'));
    const colorLabel = labels.find((label) => label.textContent.trim().toLowerCase().startsWith('color'));
    const target = colorLabel ? colorLabel.closest('fieldset, .product-form__input') : picker.firstElementChild;
    if (!target) return;
    const prompt = document.createElement('p');
    prompt.className = 'olds-cool-color-prompt';
    prompt.innerHTML = 'Choose a <span class="oc-color-letter oc-c1">C</span><span class="oc-color-letter oc-c2">O</span><span class="oc-color-letter oc-c3">L</span><span class="oc-color-letter oc-c4">O</span><span class="oc-color-letter oc-c5">R</span> below to see how your shirt is going to look.';
    target.parentNode.insertBefore(prompt, target);
  }

  function moveCompliance(info, description, buyButtons) {
    if (!buyButtons || info.querySelector('.olds-cool-compliance')) return;
    const extracted = extractPassage(description, 'In compliance with', 'Size guide');
    if (extracted) {
      const compliance = document.createElement('div');
      compliance.className = 'olds-cool-compliance rte';
      compliance.appendChild(extracted);
      buyButtons.insertAdjacentElement('afterend', compliance);
      return;
    }
    const blocks = Array.from(description.children);
    const sizeIndex = blocks.findIndex((block) => /size\s+guide/i.test(block.textContent));
    const complianceIndex = blocks.findIndex((block) => /general product safety regulation|gpsr|product safety related inquiries/i.test(block.textContent));
    if (complianceIndex < 0) return;
    const end = sizeIndex > complianceIndex ? sizeIndex : blocks.length;
    const compliance = document.createElement('div');
    compliance.className = 'olds-cool-compliance rte';
    blocks.slice(complianceIndex, end).forEach((block) => compliance.appendChild(block));
    buyButtons.insertAdjacentElement('afterend', compliance);
  }

  function syncHomepageHeader() {
    document.querySelectorAll('.olds-cool-shop').forEach((shop) => {
      const tagline = shop.querySelector('.olds-cool-tagline');
      const established = shop.querySelector('.olds-cool-established');
      if (!tagline || !established) return;
      const sync = () => {
        established.style.width = tagline.getBoundingClientRect().width + 'px';
        established.style.marginLeft = 'auto';
        established.style.marginRight = 'auto';
      };
      sync();
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(tagline);
      window.addEventListener('resize', sync, { passive: true });
    });
  }

  function enhanceProductPage() {
    document.querySelectorAll('.product__info-container').forEach((info) => {
      const description = info.querySelector('.product__description');
      const productForm = info.querySelector('.product-form');
      const buyButtons = productForm ? productForm.parentElement : null;
      addColorPrompt(info);
      if (!description) return;
      cleanDescription(description);
      moveCompliance(info, description, buyButtons);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { syncHomepageHeader(); enhanceProductPage(); });
  } else {
    syncHomepageHeader();
    enhanceProductPage();
  }
})();
